export const initialState = sessionStorage.getItem("payloadout") || false;
export const reducer = (state, action) => {
  if (action.type === "USER") {
    return action.payload;
  }
 
  return state;
};
